import { HazardSeverityDocument } from '../HazardSeverities/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  GroundHazardConditionTypeDocument,
  groundHazardConditionTypePullQueryBuilder,
} from './queryBuilder';

export function groundHazardConditionTypesFamilyMember(
  configBuilder: ConfigBuilder,
  hazardSeverities: FamilyMember<HazardSeverityDocument>,
): FamilyMember<GroundHazardConditionTypeDocument> {
  const syncConfig = configBuilder<GroundHazardConditionTypeDocument>(
    RxdbCollectionNameV2.GROUND_HAZARD_CONDITION_TYPES,
  );
  doNotAutoSync(syncConfig);

  // `groundHazardConditionTypePullQueryBuilder` uses `hazardConditionTypeFeed`,
  // which refers to the `hazard_condition_type` table.
  pull(syncConfig, groundHazardConditionTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.GROUND_HAZARD_CONDITION_TYPES, replicationState, [
    hazardSeverities,
  ]);
}
